import {
  DEFAULT_APP_LOCALE,
  SUPPORTED_APP_LOCALES,
  type AppLocale,
} from "@membentry/shared-types";

export const locales = SUPPORTED_APP_LOCALES;

export const defaultLocale = DEFAULT_APP_LOCALE;

export type Locale = AppLocale;
